
        Component.define('news-popup', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */


const $el         = $(el);
const $overlay    = $el.find('.pop-overlay');
const $newsletter = $el.find('[data-component="newsletter"]');
const $btnClose   = $el.find('.btn-close');

$el.on('popup:open', function () {
    sessionStorage.setItem('popup', true);

    TweenMax.set($el, { opacity: 0, display: 'block' });
    TweenMax.to($el, .4, { opacity: 1 });

    TweenMax.set($newsletter, { opacity: 0, display: 'block', marginTop: 50 });
    TweenMax.to($newsletter, .4, { opacity: 1, marginTop: 0 });
});

$el.on('popup:close', function () {
    TweenMax.to($el, .4, { opacity: 0, onComplete() {
        TweenMax.set($el, { display: 'none' });
    } });
});


if ($('.-feeed-internal').length) {
    $window.on('scroll', function () {
        const y = $window.scrollTop();
        const yLimit = $('#feed-related').offset().top;

        if (y + wH >= yLimit) {
            if (!sessionStorage.getItem('popup')) {
                $el.trigger('popup:open');
            }
        }
    });

    $overlay.on('click', function () {
        $el.trigger('popup:close');
    });

    $btnClose.on('click', function () {
        $el.trigger('popup:close');
    });

    $newsletter.on('click', '.close-modal', function (event) {
        event.preventDefault();
        $el.trigger('popup:close');

        return false;
    });
}

        });